import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../../hooks/useGraphQLMutation.hook';

export const UserPage_User_Foapu_Mutation = graphql(`
  mutation UserPage_User_Foapu(
    $filter: IdFilterInput!
    $update: UserPartialInput!
  ) {
    findOneAndPartialUpdateUser(filter: $filter, update: $update) {
      _id
    }
  }
`);

export const useFoapuUserMutation = () =>
  useGraphQLMutation(UserPage_User_Foapu_Mutation);
